import React, { useState } from 'react';
import { EditComponent } from '..';
import css from './SectionSkills.css';
import ScoreBadge from '../../../../components/ScoreBadge/ScoreBadge';
import { ConditionalWrapper } from '../../../../util/common';
import { Button, ToggleText } from '../../../../components';
import { getHeightByNumberOfLines } from '../../../../util/data';
import classNames from 'classnames';

const linesNum = 3;

const SectionSkills = ({
    publicData,
    isOwnListing,
    editParams,
    isMobile,
    scoreData,
    isLoggedOut,
    authorDisplayName,
    isDraftVariant,
}) => {
    const [ref, setRef] = useState(null);

    const { skillsGeneral, skillsExperience } = publicData;
    const primarySkillsExist = Boolean(skillsGeneral && skillsGeneral.length > 0);
    const experienceBasedSkillsExist = Boolean(skillsExperience && skillsExperience.length > 0);
    const noData = !primarySkillsExist && !experienceBasedSkillsExist;

    if (isLoggedOut && noData) return null;

    const showNoDataForLoggedInViewer =
        (isDraftVariant || (!isOwnListing && !isLoggedOut)) && noData;
    const showAddNewItemButton = !isDraftVariant && isOwnListing && noData;
    const editAllowed = !isDraftVariant && !noData && isOwnListing;
    const showScoreData = scoreData && typeof scoreData.skillSCore === 'number';

    const maxHeight = ref
        ? getHeightByNumberOfLines(ref, linesNum)
        : { isExceeded: true, refMaxHeight: 0 };

    return (
        <div className={css.root}>
            <h2
                className={classNames(css.title, {
                    [css.titleWithScore]: Boolean(showScoreData),
                })}
            >
                <span className={css.dtOnly}>Gewünschte Stärken</span>
                <span className={css.mobileOnly}>Gew. Stärken</span>

                {editAllowed ? <EditComponent pageName="skills" editParams={editParams} /> : null}
                {showScoreData && (
                    <div className={css.matchingContainer}>
                        <ScoreBadge scoreData={{ total: scoreData.skillSCore, maxScore: 100 }} />
                    </div>
                )}
            </h2>

            <div className={css.contentHolder}>
                {showNoDataForLoggedInViewer && (
                    <p>{authorDisplayName} hat keine Anforderungen hinzugefügt.</p>
                )}
                {!noData && (
                    <ConditionalWrapper
                        condition={isMobile}
                        wrapper={children => (
                            <ToggleText maxHeight={maxHeight.refMaxHeight}>{children}</ToggleText>
                        )}
                    >
                        <section ref={setRef}>
                            {primarySkillsExist && (
                                <div>
                                    <p>Das zeichnet dich aus:</p>
                                    <div className={css.skillsList}>
                                        {skillsGeneral.map((skill, i) => (
                                            <div className={css.skillBox} key={`skill-${i}`}>
                                                {skill}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {experienceBasedSkillsExist && (
                                <div
                                    className={classNames({
                                        [css.visualSeparator]: primarySkillsExist,
                                    })}
                                >
                                    <p>Du hast Erfahrung mit:</p>
                                    <div className={css.skillsList}>
                                        {skillsExperience.map((skill, i) => (
                                            <div className={css.skillBox} key={`skill-${i}`}>
                                                {skill}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </section>
                    </ConditionalWrapper>
                )}
                {showAddNewItemButton && (
                    <EditComponent
                        pageName="skills"
                        editParams={editParams}
                        rootClassName={css.addNewItemButton}
                    >
                        <Button>Fähigkeiten hinzufügen</Button>
                    </EditComponent>
                )}
            </div>
        </div>
    );
};

export default SectionSkills;
